export enum AlertTypeEnum {
    DEFAULT = 'default',
    SECONDARY = 'secondary',
}

export enum AlertSeverityTypeEnum {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warn',
    INFO = 'info',
    CUSTOM = 'custom',
}
